import React from 'react';

import EditNoteIcon from '@mui/icons-material/EditNote';
import { IconButton, Tooltip } from '@mui/material';

interface Props {
  href?: string;
}

export default function ManageRoomRateBlackoutDatesAction({ href }: Props) {
  if (!href) {
    return null;
  }

  return (
    <Tooltip title="Manage room-rate blackout dates">
      <IconButton
        aria-label="Manage room-rate blackout dates"
        color="primary"
        component="a"
        href={href}
        rel="noreferrer"
        size="small"
        target="_blank"
      >
        <EditNoteIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
